import {
  JceHomepageGeographyInput,
  useUpdateJceHomepageGeographyMutation,
} from 'generated/graphql';
// import { Toggle } from '@tocktix/pantry';
import { SwitchField } from 'ui';
import React from 'react';

interface PriorityEditToggleProps {
  isUnlocked: boolean;
  onUnlockedChanged: (isUnlocked: boolean) => void;
  pendingUpdates: JceHomepageGeographyInput[];
  onSaveComplete: () => void;
}

const PriorityEditToggle: React.FC<PriorityEditToggleProps> = ({
  isUnlocked,
  onUnlockedChanged,
  pendingUpdates,
  onSaveComplete,
}) => {
  const [updateGeography] = useUpdateJceHomepageGeographyMutation();
  const [isSaving, setIsSaving] = React.useState(false);

  const handleChange = async (isUnlocked: boolean) => {
    if (isUnlocked) {
      onUnlockedChanged(true);
    } else {
      setIsSaving(true);
      await Promise.all(
        pendingUpdates.map((geography) => updateGeography({ variables: { geography } }))
      );
      onSaveComplete();
      setIsSaving(false);
      onUnlockedChanged(false);
    }
  };

  return (
    <div style={{ margin: '24px 0 0 8px' }}>
      <SwitchField
        label={
          isUnlocked
            ? 'unlocked (lock to save changes)'
            : 'locked (unlock to change "priority within tier" values across geographies)'
        }
        checked={isUnlocked}
        onChange={(e) => {
          void handleChange(e.target.checked);
        }}
        disabled={isSaving}
      />
    </div>
  );
};

export default PriorityEditToggle;
